import React, { useState, useEffect } from "react";
import axios from "axios";
import InfoCard from "./Components/Info-Card";
import "./App.css";
import PopularityChart from "./Components/Popularity-Chart";
import ErrorBoundary from "./ErrorBoundary";

const API_URL =
  process.env.REACT_APP_API_URL || "https://repodash-backend.onrender.com";

function App() {
  // State to store repository data
  const [repoData, setRepoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [repoOwner, setRepoOwner] = useState("");
  const [repoName, setRepoName] = useState("");

  // Hardcoded values for now
  // const owner = "facebook";
  // const repo = "react";

  // Endpoint to test for no license
  // const owner = "SunnyD33";
  // const repo = "PomodoroGo";

  const validateGitHubInput = (input, type = "owner/repo") => {
    if (!input || input.trim().length === 0) {
      return { valid: false, error: `${type} is required` };
    }

    const trimmed = input.trim();
    const githubStringPattern = /^[a-zA-Z0-9._-]+$/;

    if (trimmed.startsWith("-") || trimmed.endsWith("-")) {
      return {
        valid: false,
        error: `${type} cannot start or end with a hyphen`,
      };
    }

    if (trimmed.length > 39) {
      return { valid: false, error: `${type} must be 39 characters or less` };
    }

    if (!githubStringPattern.test(trimmed)) {
      return { valid: false, error: `${type} contains invalid characters` };
    }

    return { valid: true, cleaned: trimmed };
  };

  const getRepoData = async (formData) => {
    setRepoData(null);
    setError(null);
    setLoading(true);

    //const baseUrl = "http://localhost:8000";
    const repoOwnerName = formData.get("repo-owner-name");
    const endpoint = `/api/repo/${repoOwnerName}`;
    let splitRepoString = repoOwnerName.split("/");
    const fullUrl = API_URL + endpoint;
    console.log("URL called:", fullUrl);

    const repoOwnerNameValue = splitRepoString[0];
    const repoNameValue = splitRepoString[1];

    //console.log("Repo Owner: ", repoOwnerNameValue);
    //console.log("Repo Name: ", repoNameValue);

    // Check that input field has valid data
    const ownerCheck = validateGitHubInput(repoOwnerNameValue, "Owner");
    const repoCheck = validateGitHubInput(repoNameValue, "Repository");

    if (!ownerCheck.valid) {
      setError(ownerCheck.error);
      setLoading(false);
      return;
    }

    if (!repoCheck.valid) {
      setError(repoCheck.error);
      setLoading(false);
      return;
    }

    try {
      // Successful retrieval of data
      const response = await axios.get(fullUrl);
      console.log("API response:", response.data);

      setRepoData(response.data);
      setRepoOwner(splitRepoString[0]);
      setRepoName(splitRepoString[1]);
      console.log("Called setRepoData with:", response.data);
    } catch (error) {
      // Something has gone wrong
      console.log("API Error:", error);
      setError(error.message);
    }

    // Processing has completed
    setLoading(false);
  };

  console.log("Current repoData state:", repoData);
  console.log("repoData.basic_info:", repoData?.basic_info);

  return (
    <div className="App">
      <h1 className="App-title">RepoDash</h1>
      <form className="Repo-Search-Form-Container" action={getRepoData}>
        <input name="repo-owner-name" placeholder="e.g. facebook/react" />
        <button type="submit">Show Repo Analytics</button>
      </form>

      <div>
        {repoOwner && <p>Owner: {repoOwner}</p>}
        {repoName && <p>Repo Name: {repoName}</p>}
      </div>

      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}
      {/* {repoData && <pre>{JSON.stringify(repoData, null, 2)}</pre>} */}

      {repoData && (
        <div className="Info-Card-Container">
          {repoData.basic_info && (
            <InfoCard title={"Basic Information"} data={repoData.basic_info} />
          )}
          {repoData.activity_group && (
            <InfoCard title={"Activity"} data={repoData.activity_group} />
          )}
          <div>
            {repoData.popularity_group && (
              <ErrorBoundary fallback={<p>Failed to load popularity chart</p>}>
                <PopularityChart repoData={repoData.popularity_group} />
              </ErrorBoundary>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
